import Login from './src/Login.vue';

Login.install = function (app) {
  app.component(Login.name, Login)
}

export default Login


//////////////////
// WEBPACK FOOTER
// ./packages/login/index.js
// module id = null
// module chunks = 